import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Hero4.css";

const ROTATOR = [
  "mutual funds",
  "SIP portfolios",
  "IPO advice",
  "bonds & SGBs",
  "unlisted shares",
  "tax planning",
  "business loans",
];

const MARQUEE = [
  "NIFTY 50",
  "SENSEX",
  "Mutual Funds",
  "SIP Investing",
  "Gold & SGB",
  "IPO Advisory",
  "Bonds",
  "Unlisted Shares",
  "Portfolio Review",
  "₹ Wealth Creation",
];

const VIDEOS = [
  `${process.env.PUBLIC_URL}/assets/video/hero-india.mp4`,
  `${process.env.PUBLIC_URL}/assets/video/hero-india-alt.mp4`,
  `${process.env.PUBLIC_URL}/assets/video/hero-india-finance.mp4`,
];

export default function Hero4() {
  const [wordIdx, setWordIdx] = useState(0);
  const [activeVid, setActiveVid] = useState(0);
  const videoRefs = useRef([]);

  useEffect(() => {
    const id = setInterval(() => {
      setWordIdx((i) => (i + 1) % ROTATOR.length);
    }, 2200);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const videos = videoRefs.current.filter(Boolean);

    const prep = (video) => {
      try {
        video.playbackRate = 0.5;
      } catch {
        /* ignore */
      }
      const p = video.play();
      if (p?.catch) p.catch(() => {});
    };

    videos.forEach(prep);

    // Crossfade between Indian advisory scenes
    const swap = setInterval(() => {
      setActiveVid((i) => (i + 1) % VIDEOS.length);
    }, 7000);

    return () => clearInterval(swap);
  }, []);

  useEffect(() => {
    videoRefs.current.forEach((video, i) => {
      if (!video) return;
      try {
        video.playbackRate = 0.5;
      } catch {
        /* ignore */
      }
      if (i === activeVid) {
        const p = video.play();
        if (p?.catch) p.catch(() => {});
      }
    });
  }, [activeVid]);

  const marqueeItems = [...MARQUEE, ...MARQUEE];

  return (
    <section className="hero4" id="home">
      <div className="hero4-video-wrap" aria-hidden="true">
        {VIDEOS.map((src, i) => (
          <video
            key={src}
            ref={(el) => {
              videoRefs.current[i] = el;
            }}
            className={`hero4-video ${i === activeVid ? "is-active" : ""}`}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src={src} type="video/mp4" />
          </video>
        ))}
        <div className="hero4-video-overlay" />
        <div className="hero4-india-glow" />
      </div>
      <div className="aurora" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />
      <div className="container hero4-inner">
        <div>
          <span className="h4-eyebrow">
            <span className="pulse" />
            INDIA&apos;S WEALTH DESK · CFA · CA · CS · AMFI
          </span>
          <h1>
            <span className="line">
              <span>Paisa.</span>
            </span>
            <span className="line">
              <span>Meet your</span>
            </span>
            <span className="line">
              <span>
                <span className="grad-shimmer">mitra.</span>
              </span>
            </span>
          </h1>
          <p className="h4-rot">
            One expert team for your&nbsp;
            <span className="rot-word" key={ROTATOR[wordIdx]}>
              {ROTATOR[wordIdx]}
            </span>
          </p>
          <div className="h4-ctas">
            <Link to="/contact" className="btn-mag">
              <span>Get started — it&apos;s free</span>
            </Link>
            <Link to="/portfolio-review" className="h4-ghost">
              <span className="play-ic">▶</span>
              See a portfolio review
            </Link>
          </div>
          <div className="h4-stats">
            <div className="h4-stat">
              <b>₹40Cr+</b>
              <span>Managed</span>
            </div>
            <div className="h4-stat">
              <b>1,500+</b>
              <span>Families</span>
            </div>
            <div className="h4-stat">
              <b>4.9★</b>
              <span>Google Rating</span>
            </div>
            <div className="h4-stat">
              <b>₹0</b>
              <span>Hidden Charges</span>
            </div>
          </div>
        </div>

        <div className="hero4-stack" aria-hidden="true">
          <div className="hero4-gcard hero4-gc1">
            <small>AUM Snapshot</small>
            <span className="hero4-badge-live">
              <span className="pulse" style={{ width: 6, height: 6 }} />
              LIVE
            </span>
            <div className="gv">₹40 Cr+</div>
            <div className="gd">▲ Assets under management</div>
            <svg viewBox="0 0 260 56" preserveAspectRatio="none">
              <defs>
                <linearGradient id="hero4sg" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0" stopColor="#3FD68F" stopOpacity="0.4" />
                  <stop offset="1" stopColor="#3FD68F" stopOpacity="0" />
                </linearGradient>
              </defs>
              <path
                d="M0,44 C30,40 45,30 70,32 S110,20 140,22 S190,10 215,12 L260,4 L260,56 L0,56 Z"
                fill="url(#hero4sg)"
              />
              <path
                d="M0,44 C30,40 45,30 70,32 S110,20 140,22 S190,10 215,12 L260,4"
                fill="none"
                stroke="#3FD68F"
                strokeWidth="2"
              />
            </svg>
          </div>

          <div className="hero4-gcard hero4-gc2">
            <small>Portfolio Health</small>
            <div className="row">
              <svg className="ring" viewBox="0 0 42 42">
                <circle
                  cx="21"
                  cy="21"
                  r="16"
                  fill="none"
                  stroke="rgba(255,255,255,.12)"
                  strokeWidth="4.5"
                />
                <circle
                  cx="21"
                  cy="21"
                  r="16"
                  fill="none"
                  stroke="#E3A81C"
                  strokeWidth="4.5"
                  strokeDasharray="72 28"
                  strokeDashoffset="25"
                  strokeLinecap="round"
                />
                <text
                  x="21"
                  y="25"
                  textAnchor="middle"
                  fontSize="11"
                  fontWeight="700"
                  fill="#F6D77C"
                >
                  72
                </text>
              </svg>
              <p>
                <b style={{ color: "#fff" }}>3 expert suggestions</b>
                <br />
                Rebalance · Reduce overlap · Harvest LTCG
              </p>
            </div>
          </div>

          <div className="hero4-gcard hero4-gc3">
            <small>SIP Projection</small>
            <div className="sip-row">
              <span>₹15,000 / mo · 12%</span>
              <b>15 yrs</b>
            </div>
            <div className="sip-row">
              <span>Invested</span>
              <b>₹27 L</b>
            </div>
            <div className="sip-row">
              <span>Projected corpus</span>
              <b>₹75.2 L</b>
            </div>
          </div>
        </div>
      </div>

      <div className="hero4-scroll-hint" aria-hidden="true" />
      <div className="hero4-marquee" aria-hidden="true">
        <div className="hero4-marquee-track">
          {marqueeItems.map((item, i) => (
            <span key={`${item}-${i}`}>{item}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
